<template>
  <main>
    <!-- {{ 'ans:'+JSON.stringify(answer) }} -->
    <!-- <header>
      <div class="survey-title">
        <img src="@/assets/images/telltomm.svg" alt="TellTOMM Logo" />
        <p v-if="question">{{ question.preset.name }}</p>
      </div>

      <p class="question-title" v-if="question && question.title">
        <strong v-html="bb(question.title)"></strong>
      </p>
      <p
        class="question-subtitle"
        v-if="question && question.subtitle"
        v-html="bb(question.subtitle)"
      ></p>
    </header> -->
    
    
    <Header :question="question"></Header>



    <section>
      <component
        v-if="question"
        :is="tag"
        :question="question"
        :answer="answer"
        v-model="answer"
      />
    </section>

    <footer>
      <button @click="goBack" class="btn-back">
        <div><span>back</span></div>
        <div><div class="left-arrow"></div></div>
        <div></div>
        <div></div>
      </button>

      <button v-if="hasAnswer" class="btn-next" @click="next">
        <div></div>
        <div></div>
        <div><div class="right-arrow"></div></div>
        <div><span>next</span></div>
      </button>

      <button v-else-if="question && question.optional" class="btn-unsure-skip">
        <div></div>
        <div><div class="right-arrow"></div></div>
        <div @click="unsure"><span>not sure</span></div>
        <div @click="skip"><span>skip</span></div>
      </button>
    </footer>
  </main>
</template>

<script>
import { http } from '../../plugins/HttpPlugin';
import { SurveyQuestionFactory } from '../../app/factories/SurveyQuestionFactory';
import bbCodeParser from 'js-bbcode-parser';
import Header from './Header.vue';

async function getQuestion(id = undefined) {
  let response;
  const url = id ? `/survey/question/before/${id}` : '/survey/question';

  try {
    response = await http.get(url);
  } catch ({ response }) {
    throw response;
  }

  return response.data;
}

export default {
  name: 'question',
  components:{
    Header,
  },

  data() {
    return {
      question: undefined,
      answer: undefined,
      isUnsure: false,
    };
  },

  computed: {
    tag() {
      return SurveyQuestionFactory.make(this.question.type.type);
    },

    hasAnswer() {
      return this.answer !== null && this.answer !== undefined;
    },
  },

  methods: {
    bb(str) {
      return bbCodeParser.parse(str);
    },

    goBack() {
      this.$router.push({
        name: 'survey-question',
        params: { id: this.question.id },
      });
    },

    unsure() {
      this.isUnsure = true;
      this.answer = null;
      this.next();
    },

    skip() {
      this.isUnsure = false;
      this.answer = null;
      this.next();
    },

    async next() {
      try {
        let response;

        if (this.question.answers.length > 0) {
          response = await this.$http.post('/survey/answer', {
            answerId: this.question.answers[0].id,
            answer: this.answer,
            unsure: this.isUnsure,
          });
        } else {
          response = await this.$http.put('/survey/answer', {
            questionId: this.question.id,
            answer: this.answer,
            unsure: this.isUnsure,
          });
        }

        if (response.data.question === null) {
          localStorage.removeItem('compulsoryPoint');
          // Logout logic.
          await this.$http.delete('/survey/logout');
          let type = 0;
          if(response.data.preset_name == 'ASQ3')
            type = 1;
          else if(response.data.preset_name == 'ASQ-SE')
            type = 2;
          this.$router.push({
            name: 'thank-you',
            params: { type: type },
          });
        }

        this.question = response.data.question;
        if (response.data.question!=null && response.data.question.answers[0]) {
          this.answer = response.data.question.answers[0].answer;
        }
        else{
          this.answer = null;
          this.isUnsure = false;
        }
      } catch ({ response }) {
        alert('ERROR');
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    getQuestion(to.params.id || undefined).then(question =>
      next(vm => {
        vm.question = question
        if (question.answers[0]) {
          vm.answer = question.answers[0].answer;
        }
      }),
    );
  },

  beforeRouteUpdate(to, from, next) {
    this.answer = undefined;
    this.isUnsure = false;

    getQuestion(to.params.id || undefined).then(question => {
      this.question = question;
      if (question.answers[0]) {
        this.answer = question.answers[0].answer;
      }
      next();
    });
  },
};
</script>

<style lang="scss" scoped>
main {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 800px;
  // max-width: 1280px;
  max-width: 1080px;
  width: 100%;
  height: 100vh;
  background-color: white;
  border-radius: 25px;
  box-shadow: 0 6px 12px rgba(#000, 0.26);
  display: grid;
  grid-template-rows: 250px 1fr 60px;
  padding: 25px;
}



section {
  position: relative;
}

footer {
  display: flex;
  justify-content: space-between;

  .left-arrow {
    .left-arrow {
      width: 0;
      height: 0;
      border-top: 30px solid transparent;
      border-bottom: 30px solid transparent;
      border-right: 30px solid transparent;
      margin-left: 30px;
    }
  }

  .right-arrow {
    width: 0;
    height: 0;
    border-top: 30px solid transparent;
    border-bottom: 30px solid transparent;
    border-left: 30px solid transparent;
  }
}

.btn-back,
.btn-unsure-skip,
.btn-next {
  position: relative;
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
  display: flex;

  > div {
    position: relative;
    height: 60px;
    width: 60px;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-weight: bold;
      font-size: 15px;
    }
  }
}

.btn-unsure-skip {
  > div {
    &:nth-of-type(4) {
      position: relative;
      background-color: #854b9d;
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      cursor: pointer;
    }

    &:nth-of-type(3) {
      background-color: #f04e33;
      cursor: pointer;
    }

    &:nth-of-type(2) {
      background-color: #feeeeb;

      .right-arrow {
        border-left-color: #fcd7d0;
      }
    }

    &:nth-of-type(1) {
      background-color: #fef7f5;
    }
  }
}

.btn-next {
  > div {
    &:nth-of-type(4) {
      position: relative;
      background-color: #03aaa8;
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      cursor: pointer;
    }

    &:nth-of-type(3) {
      background-color: #cceeee;

      .right-arrow {
        border-left-color: #aee4e4;
      }
    }

    &:nth-of-type(2) {
      background-color: #e6f7f6;
    }

    &:nth-of-type(1) {
      background-color: #f3fbfb;
    }
  }
}

.btn-back {
  > div {
    &:nth-of-type(1) {
      position: relative;
      background-color: #faad41;
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
      cursor: pointer;
    }

    &:nth-of-type(2) {
      background-color: #feefd9;

      .left-arrow {
        border-right-color: #fde5c3;
      }
    }

    &:nth-of-type(3) {
      background-color: #fff7ec;
    }

    &:nth-of-type(4) {
      background-color: #fffbf6;
    }
  }
}
</style>
